export default __webpack_public_path__ + "static/media/about-5.9dae397a.webp";